import {
  ACTIVATE_COUPON_REQUEST,
  DEACTIVATE_COUPON_REQUEST,
  FETCH_COUPONS_REQUEST,
} from "@/types/coupon";
import { CouponFilters } from "@/types/coupon/filter";

export const fetchCoupons = (payload: {
  page: number;
  page_size: number;
  filters?: CouponFilters;
}) => ({
  type: FETCH_COUPONS_REQUEST,
  payload,
});

export const activateCoupon = (couponId: string) => ({
  type: ACTIVATE_COUPON_REQUEST,
  payload: couponId,
});

export const deactivateCoupon = (couponId: string) => ({
  type: DEACTIVATE_COUPON_REQUEST,
  payload: couponId,
});

export const couponActions = {
  fetchCoupons,
  activateCoupon,
  deactivateCoupon,
};
